// Components==============
import Avatar from 'components/UI/Avatar/Avatar';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import React, { useContext } from 'react';
import { DeleteModalContext } from '../../DeleteModal';
import '../../DeleteModal.module.scss';
// =========================

const TransferUser = ({ user }: { user: UserEntity }) => {
  const { transferUser, setTransferUser } = useContext(DeleteModalContext);

  return (
    <Checkbox
      isChecked={user.id === transferUser?.id}
      onClick={() => setTransferUser((prev) => (!prev ? user : undefined))}
    >
      <div styleName="user">
        <Avatar user={user} />
        <p>
          {user.first_name} {user.last_name}
        </p>
      </div>
    </Checkbox>
  );
};

export default function Transfer() {
  const { transferableUsers } = useContext(DeleteModalContext);

  return (
    <div styleName="body">
      {transferableUsers?.map(
        (u) => !!u && <TransferUser key={u.id} user={u} />
      )}
    </div>
  );
}
